var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#028789"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.313 71.8163C45.3963 71.8163 41.4604 71.8163 37.5437 71.8163C35.5758 71.8163 33.7416 71.3577 32.1367 70.1732C30.3407 68.8357 29.2708 67.0207 29.0988 64.7853C28.774 60.7921 29.2325 56.8945 30.7037 53.1497C31.6208 50.8379 32.9773 48.8699 35.251 47.6471C36.6457 46.902 38.136 46.5581 39.6836 46.5963C40.2185 46.6154 40.7726 46.902 41.2694 47.1695C42.3393 47.7809 43.3328 48.5451 44.441 49.0801C48.224 50.9334 51.9305 50.6277 55.4842 48.3923C56.0574 48.0293 56.6497 47.6854 57.2038 47.2841C58.1591 46.5581 59.229 46.4817 60.3754 46.6536C63.5852 47.1313 65.8397 48.9081 67.3491 51.7358C68.6674 54.2005 69.2597 56.8563 69.5272 59.6075C69.6609 60.9641 69.7182 62.3397 69.7182 63.6962C69.6991 68.0906 66.7759 71.2813 62.4006 71.7208C61.8848 71.7781 61.3498 71.7972 60.8339 71.7972C56.9745 71.8354 53.1533 71.8354 49.313 71.8163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0455 23.0005C55.4078 22.9431 60.8531 28.2355 60.7957 34.7889C60.7575 41.3232 55.5607 46.5009 49.0264 46.52C42.5113 46.5582 37.238 41.1512 37.2762 34.7507C37.2953 28.2355 42.5304 23.0005 49.0455 23.0005Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.715840e163dc05769218e838f11f7ffa.svg";
export { ForwardRef as ReactComponent };